import AuthCloudService from '../../../service/auth-cloud/AuthCloudService';
import { exchangeCodeForToken } from '../../../shared/util/auth/oidcUtils';
import { AuthInfo } from '../../../service/auth/AuthService.model';
import Environment from '../../../shared/constants/Environment';
import AuthIDPAPI from '../../../service/auth/AuthIDPAPI';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { nameReducer } from '../AuthManager.model';
import { RootState } from '../../store.model';

// ------------------------------------
// Thunks created with @reduxjs/toolkit
// ------------------------------------

export const loginManagerAThunk = createAsyncThunk(
  `${nameReducer}/authenticate`,
  async (props: { email: string; password: string }) => {
    const { password, email } = props;
    const response = await AuthCloudService.login(email, password);

    return response;
  }
);

/** use the same name because will replace the values of login */
export const refreshManagerTokenAThunk = createAsyncThunk(
  `${nameReducer}/authenticate`,
  async (props: { refreshToken: string }, thunkAPI) => {
    const { refreshToken } = props;
    const state = thunkAPI.getState() as RootState;
    const idpConfig = AuthIDPAPI.endpoints.getIDPConfig.select()(state);

    // client ID is taken from IDP config or Environment
    const clientId = idpConfig?.data?.clientId ?? Environment.clientID;

    // client secret is taken from Environment and must be empty
    // when not in use. Otherwise, the auth-service does the wrong
    // validation...
    const clientSecret = Environment.clientSecret;

    const response = await AuthCloudService.refreshToken(
      refreshToken,
      clientId,
      clientSecret
    );

    return response;
  }
);

export const loginManagerSSOThunk = createAsyncThunk(
  `${nameReducer}/authenticate`,
  async (props: { code: string }) => {
    const { code } = props;
    const response = await exchangeCodeForToken(code).then((response) => {
      if (response.error) {
        throw new Error(response.error);
      }
      return new AuthInfo(response.data).getPayload();
    });
    return response;
  }
);
